// extracted by mini-css-extract-plugin
export default {"container":"layout-styles_component_container__hBnt9","header":"layout-styles_component_header__EZYku","content":"layout-styles_component_content__4fQWg"};